"use strict";
/*
 * Created on 10 15 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * UserProductCategoryConverter
 *
 * @author JMe
 */


var UserProductCategoryConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(UserProductCategoryConverter, _DataObjectConverter_);

  function UserProductCategoryConverter() {
    _classCallCheck(this, UserProductCategoryConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserProductCategoryConverter).apply(this, arguments));
  }

  return UserProductCategoryConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.UserProductCategoryConverter = UserProductCategoryConverter;